import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ManagerService } from 'src/app/core';
import { HttpEventType, HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-document-proofs',
  templateUrl: './document-proofs.component.html',
  styleUrls: ['./document-proofs.component.scss']
})
export class DocumentProofsComponent implements OnInit {

  constructor(@Inject(DOCUMENT) private document: Document, 
  public dialogRef: MatDialogRef<DocumentProofsComponent>,
  @Inject(MAT_DIALOG_DATA) public data, private managerService: ManagerService) { }

  @ViewChild('fileInput') fileInput;
  showStatusScreen: boolean = true;
  showUploadDocScreen: boolean = false;
  showChatScreen: boolean = false;
  fileData: any = null;
  fileName: any = '';
  comments: any = '';
  docUploading: boolean = false;
  uploadProgress: any = null;
  docUploadSuccess: boolean = false;
  docUploadFailed: boolean = false;
  documentsList: any = {};
  selectedFileId: any = null;
  dataLoaded: boolean = false;
  chatData: any = {};

  ngOnInit() {
    this.loadCiscoStyles('client-cisco.css');
    this.getDocProofsList()
  };

  getDocProofsList() {
    this.managerService.getProofOfDocumentsList(this.data.userChallengeId).subscribe((data) => {
      this.documentsList = data;
      this.dataLoaded = true;
    }, err => {
      console.log(err)
      this.dataLoaded = true;
    });
  };

  getDocHistory(item) {
    return this.documentsList[item].slice(1);
  };

  getDocumentList() {
    return Object.keys(this.documentsList);
  }

  showUploadProofLayout() {
    this.showStatusScreen = false;
    this.showUploadDocScreen = true;
    this.showChatScreen = false;
    this.docUploadSuccess = false;
    this.docUploadFailed = false;
  };

  showDocStatusLayout() {
    this.showStatusScreen = true;
    this.showUploadDocScreen = false;
    this.showChatScreen = false;
    this.fileData = null;
  };

  upload() {
    document.getElementById("getFile").click();
  };

  getFile(eve) {
    this.fileData = eve.target.files[0];
    this.fileName = this.fileData.name;
    this.fileInput.nativeElement.value = '';
  };

  clearFile() {
    this.fileData = null;
    this.selectedFileId = null;
    this.comments = null;
    this.fileName = '';
  };

  closeDialog() {
    this.dialogRef.close();
  };

  openChatModal(fileData, docItem) {
    this.showStatusScreen = false;
    this.showUploadDocScreen = false;
    this.showChatScreen = true;
    this.chatData = {
      fileData: {...fileData, docName: docItem.key},
      userChallengeId: this.data.userChallengeId
    };
  };

  onChatScreenBack() {
    this.showStatusScreen = true;
    this.showUploadDocScreen = false;
    this.showChatScreen = false;
  };

  submitDocument() {
    this.docUploading = true;
    this.uploadProgress = 0;
    this.docUploadSuccess = false;
    this.docUploadFailed = false;
    let formData = new FormData();
    formData.append('file-to-be-uploaded', this.fileData);
    const params = '?fileName='+this.fileName+'&comment='+this.comments+'&docTypeId='+this.selectedFileId.id;
    this.managerService.acSubmitProofs(this.data.userChallengeId, formData, params).subscribe(data=>{
      if(data.type === HttpEventType.UploadProgress){
        this.uploadProgress = Math.round((100 / data.total) * data.loaded)
      }
      else if (data instanceof HttpResponse) {
        this.docUploading = false;
        this.docUploadSuccess = true;
        this.showStatusScreen = true;
        this.showUploadDocScreen = false;
        this.showChatScreen = false;
        this.getDocProofsList();
        this.clearFile();
        setTimeout(() => {
          this.docUploadSuccess = false;
        }, 5000);
      }
     },(error)=>{
       this.docUploading = false;
       this.docUploadFailed = true;
     })
  };

  getLocalDate(data) {
    return data ? new Date(data).toLocaleDateString() : null
  };

  getFileType(fileName) {
    let fileImage = '<span class="icon-file-o"></span>'
    if (fileName) {
      const extension = fileName.split('.')[fileName.split('.').length - 1].toLowerCase()
      if (extension === 'pdf') {
        fileImage = '<span class="icon-file-pdf-o"></span>'
      }
      if (extension === 'xls' || extension === 'xlsx' || extension === 'xlsm') {
        fileImage = '<span class="icon-file-excel-o"></span>'
      }
      if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') {
        fileImage = '<span class="icon-file-image-o"></span>'
      }
    }
    return fileImage;
  };

  getClassByFileType(fileName) {
    let fileColor = ''
    if (fileName) {
      const extension = fileName.split('.')[fileName.split('.').length - 1].toLowerCase()
      if (extension === 'pdf') {
        fileColor = 'pdf-color'
      }
      if (extension === 'xls' || extension === 'xlsx' || extension === 'xlsm') {
        fileColor = 'excel-color'
      }
      if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') {
        fileColor = 'image-color'
      }
    }
    return fileColor;
  };

  loadCiscoStyles(styleName) {
    const head = this.document.getElementsByTagName('head')[0];
    const styleLink = this.document.createElement('link');
    styleLink.rel = 'stylesheet';
    styleLink.classList.add('cisco_styles')
    styleLink.href = styleName;
    head.appendChild(styleLink);
  };

  ngOnDestroy(): void {
    let ciscoLinkElement = document.head.querySelector(`link[rel="stylesheet"].${'cisco_styles'}`);
    if (ciscoLinkElement) {
      document.head.removeChild(ciscoLinkElement);
    };
  };
}
